import { graphqlFetch } from '@pylot-data/graphqlFetch'
import getCMSBlocks from '@pylot-data/hooks/cms/graphql/getCMSBlocks'
import {
    CmsBlock,
    InterleavedContent,
    MarketingTile,
    Maybe
} from '@pylot-data/pylotschema'

export const getCMSPageQuery = /* GraphQL */ `
    query getCMSPage($identifier: String!) {
        cmsPage(identifier: $identifier) {
            content
        }
    }
`

interface Variables {
    identifiers: string[]
}

interface MarketingResult {
    cmsBlocks: { items: CmsBlock[] }
}

async function getMarketingTiles(
    interleavedContent: Maybe<InterleavedContent[]>
): Promise<MarketingTile[]> {
    const cmsBlocksPromise = interleavedContent?.map(
        async ({ blockIdentifier, position }) => {
            if (blockIdentifier) {
                return {
                    cmsBlock: (
                        await graphqlFetch<Variables, MarketingResult>({
                            query: getCMSBlocks,
                            variables: {
                                identifiers: [blockIdentifier]
                            }
                        })
                    ).data.cmsBlocks.items[0]?.content,
                    position: position && position - 1
                }
            }

            return {
                cmsBlock: '',
                position: 0
            }
        }
    )

    if (cmsBlocksPromise) {
        const marketingTiles: MarketingTile[] = (
            await Promise.all(cmsBlocksPromise)
        ).map(({ cmsBlock, position }) => ({
            columnSpan: {
                col: 1,
                span: 0
            },
            content: cmsBlock as string,
            class: '',
            position: position as number
        }))

        return marketingTiles
    }

    return []
}

export default getMarketingTiles
